import React from 'react'
import { buildLayoutConfig, COMMON_LAYOUT_EDITABLE_FIELDS, IntroStatsPanel, LayoutSections, splitHighlightSection } from './layoutShared'

const DEFAULT_CONFIG = {
  heroBackgroundColor: '#e8f7f3',
  heroTextColor: '#111827',
  heroSubtitleColor: '#0f766e',
  formBorderColor: '#ff7b1b',
  formBorderWidth: 3,
  highlightsBackgroundColor: '#f8fafc',
}

function HanwhaStyleLayout({
  mode = 'public',
  heroTitle,
  heroSubtitle,
  heroImageFileId,
  sections = [],
  formEnabled = true,
  introStats = [],
  customConfig = {},
  resolveAssetUrl,
  formCard = null,
  recommendedProductsCard = null,
  previewBanner = null,
  surveyModal = null,
  surveyDoneModal = null,
}) {
  const config = buildLayoutConfig('hanwha-sections', customConfig, DEFAULT_CONFIG)
  const isLive = mode === 'live'
  const heroImageUrl = heroImageFileId ? resolveAssetUrl(heroImageFileId) : ''
  const heroStyle = heroImageUrl
    ? {
        backgroundColor: config.heroBackgroundColor,
        backgroundImage: `linear-gradient(90deg, rgba(255,255,255,0.94) 0%, rgba(255,255,255,0.86) 34%, rgba(255,255,255,0.28) 68%, rgba(255,255,255,0.14) 100%), url("${heroImageUrl}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }
    : { backgroundColor: config.heroBackgroundColor }
  const { highlightSection, bodySections } = splitHighlightSection(sections, true)

  return (
    <div className="min-h-full bg-white text-slate-900 relative">
      {previewBanner}
      <div style={heroStyle} className="px-4 pt-16 pb-12 md:pt-20 md:pb-14">
        <div className={`mx-auto ${isLive ? 'max-w-full' : 'max-w-7xl xl:pr-[480px] 2xl:pr-[500px]'}`}>
          <div className="flex items-center min-h-[400px] md:min-h-[470px]">
            <div className="max-w-4xl space-y-6">
              {heroTitle && (
                <h1 className="whitespace-pre-line text-5xl md:text-6xl font-extrabold tracking-tight leading-tight" style={{ color: config.heroTextColor }}>
                  {heroTitle}
                </h1>
              )}
              {heroSubtitle && (
                <p className="text-[28px] md:text-[34px] font-bold leading-[1.35] whitespace-pre-line" style={{ color: config.heroSubtitleColor }}>
                  {heroSubtitle}
                </p>
              )}
            </div>
          </div>
        </div>

        {(formEnabled || recommendedProductsCard) && (
          <>
            <div className={`mx-auto mt-8 space-y-4 ${isLive ? 'max-w-full' : 'max-w-7xl xl:hidden'}`}>
              {formEnabled && formCard}
              {recommendedProductsCard}
            </div>
            {!isLive && (
              <div className="hidden xl:flex fixed top-24 right-6 z-30 items-start gap-3">
                {formEnabled && formCard}
                {recommendedProductsCard}
              </div>
            )}
          </>
        )}
      </div>

      {highlightSection && (
        <div style={{ backgroundColor: config.highlightsBackgroundColor }} className="border-y border-slate-200 px-4 py-8">
          <div className={`mx-auto ${isLive ? 'max-w-full' : 'max-w-7xl xl:pr-[480px] 2xl:pr-[500px]'}`}>
            <LayoutSections sections={[highlightSection]} resolveAssetUrl={resolveAssetUrl} variant="compact" />
          </div>
        </div>
      )}

      <div className="px-4 py-12 md:py-14">
        <div className={`mx-auto ${isLive ? 'max-w-full space-y-4' : 'max-w-7xl xl:pr-[480px] 2xl:pr-[500px] space-y-6'}`}>
          <LayoutSections sections={bodySections} resolveAssetUrl={resolveAssetUrl} variant={isLive ? 'compact' : 'default'} />
          <IntroStatsPanel introStats={introStats} />
        </div>
      </div>

      {surveyModal}
      {surveyDoneModal}
    </div>
  )
}

export const hanwhaStyleLayout = {
  key: 'hanwha-sections',
  label: '기본 템플릿 3 - 설명형',
  description: '풀폭 히어로와 고정 상담 영역을 사용하는 강한 전환형 레이아웃입니다.',
  editableConfigFields: [
    ...COMMON_LAYOUT_EDITABLE_FIELDS,
    { key: 'highlightsBackgroundColor', label: '하이라이트 섹션 배경색', placeholder: '#f8fafc' },
  ],
  normalizeCustomConfig: (customConfig) => buildLayoutConfig('hanwha-sections', customConfig, DEFAULT_CONFIG),
  Component: HanwhaStyleLayout,
}
